export const RepeatTypeEnum = Object.freeze({
    DAILY: 'DAILY',
    WEEKDAYS: 'WEEKDAYS',
    WEEKENDS: 'WEEKENDS',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
})
